import React from 'react';
import _ from 'lodash';
import { wrapComponent } from 'utils/framework';
import BaseClass from 'components/BaseClass';

import Modal from 'components/Modal/Modal';
import { Text } from 'components/ui';
import { space, fontSizes, fontWeights } from 'style/config';

class AutoReplenishSubscriptionModal extends BaseClass {
    closeAutoReplenishSubscriptionModal = () => {
        const { onClose } = this.props;
        onClose();
    };

    render() {
        const { arTitle, arHeader, arSubscriptionScript, isOpen } = this.props;

        const createMarkup = encodedHtml => ({
            __html: _.unescape(encodedHtml)
        });

        return (
            <Modal
                isOpen={isOpen}
                onDismiss={this.closeAutoReplenishSubscriptionModal}
                isDrawer={true}
                width={0}
            >
                <Modal.Header>
                    <Modal.Title>{arTitle}</Modal.Title>
                </Modal.Header>
                <Modal.Body padding={space[5]}>
                    <Text
                        is='p'
                        fontSize={fontSizes.base}
                        fontWeight={fontWeights.medium}
                        paddingBottom={space[5]}
                    >
                        {arHeader}
                    </Text>
                    <Text
                        is='p'
                        fontSize={fontSizes.base}
                        css={styles.scriptText}
                        lineHeight='base'
                    >
                        <div dangerouslySetInnerHTML={createMarkup(arSubscriptionScript)} />
                    </Text>
                </Modal.Body>
            </Modal>
        );
    }
}

const styles = {
    scriptText: {
        whiteSpace: 'pre-line'
    }
};

export default wrapComponent(AutoReplenishSubscriptionModal, 'AutoReplenishSubscriptionModal', true);
